/**
 * Styled Components - Created by miguelcanobbio on 18/07/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin: 6px 0;
`

export const Currency = styled.div`
  display: flex;
`

export const FlagIcon = styled.img`
  margin-right: 8px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Overview/ProfileData/styledComponents.tsx